'use client';

import {
  ApplicationRef,
  ComponentRef,
  createComponent,
  EnvironmentInjector,
  NgModuleRef,
  NgZone,
  Type,
} from '@angular/core';
import 'zone.js';
import { AppModule } from '@web-app/_main/app.module';
import 'reflect-metadata';
import '@angular/compiler';

export function mountAngularComponent<T>(
  component: Type<T>,
  element: HTMLElement,
  moduleRef: NgModuleRef<AppModule>,
  mountInputsOutputs?: (componentRef: ComponentRef<T>) => void,
): ComponentRef<T> {
  const appRef = moduleRef.injector.get(ApplicationRef);
  const zone = moduleRef.injector.get(NgZone);
  const envInjector = moduleRef.injector.get(EnvironmentInjector);

  let componentRef: ComponentRef<T>;

  zone.run(() => {
    componentRef = createComponent(component, {
      environmentInjector: envInjector,
    });

    mountInputsOutputs?.(componentRef);

    // Attach the component to the Angular application
    appRef.attachView(componentRef.hostView);
    element.appendChild((componentRef.hostView as any).rootNodes[0]);
  });

  return componentRef!;
}
